import { Slide } from '@/components/core/Slide';
import imageFile from './23-phone-ar.png';

// Jonathan vertelt over AR op telefoon en hoe monteurs met AI vision geholpen kunnen worden
// Hij legt uit hoe niet iedereen een AR-bril nodig heeft, maar dat een smartphone ook kan werken
// Monteurs kunnen hun telefoon richten op een installatie en direct relevante informatie zien
// AI vision herkent componenten en kan real-time instructies, specificaties en troubleshooting geven

export const slide = () => {
  return (
    <Slide
      transition="fade"
      visualizer="bottom-right"
      background={{
        image: imageFile,
      }}
    >
      <div className="slide relative z-10">
        <h1 className="text-4xl font-bold mb-10 text-white">👓 AR voor Smartphones</h1>
      </div>
    </Slide>
  );
};
